import { getVideoMetadata } from '@remotion/media-utils';

interface AvatarDimensions {
  width: number;
  height: number;
  x: number;
  y: number;
  cropX?: number;
  cropWidth?: number;
}

export const getAvatarDimensions = (store: any, avatarUrl: string, selectedSize: string): Promise<AvatarDimensions> => {
  // Default dimensions for timeout or error
  const defaultDimensions = {
    width: store.width,
    height: store.height,
    x: 0,
    y: 0,
    cropWidth: 1,
    cropX: 1
  };

  return new Promise((resolve) => {
    // Set timeout for metadata loading
    const timeoutId = setTimeout(() => {
      console.log('Avatar metadata loading timed out, using default dimensions');
      resolve(defaultDimensions);
    }, 10000); // 10 second timeout

    // Use Remotion's getVideoMetadata instead of creating a video element
    getVideoMetadata(avatarUrl)
      .then((metadata) => {
        // Clear the timeout since we got the metadata
        clearTimeout(timeoutId);
        
        // Get aspect ratio from metadata
        const videoRatio = metadata.aspectRatio;
        
        console.log(`Video metadata loaded: ${metadata.width}x${metadata.height}, ratio: ${videoRatio}`);
        
        if (selectedSize === "9:16" || selectedSize === "1:1") {
          if (videoRatio > 1) {
            // Horizontal video in vertical mode
            resolve({ 
              width: store.width,
              height: store.height,
              x: 0,
              y: 0,
              cropWidth: 0.5,
              cropX: 0.33
            });
          } else {
            // Vertical video in vertical mode - fit width and maintain aspect ratio
            const width = store.width;
            const height = width / videoRatio;
            resolve({ 
              width,
              height,
              x: 0,
              y: (store.height - height) / 2 // Center vertically
            });
          }
        } else {
          // For 16:9, keep full dimensions and set fixed position
          resolve({
            width: store.width,
            height: store.height,
            x: 0,
            y: 0,
            cropWidth: 1,
            cropX: 0
          });
        }
      })
      .catch((error) => {
        // Clear the timeout if there's an error
        clearTimeout(timeoutId);
        console.error('Error getting avatar dimensions:', error);
        resolve(defaultDimensions);
      });
  });
}; 